import type {
  KioskRegistrationAction,
  KioskRegistrationChannelType,
  KioskRegistrationStatus,
  KioskRegistrationTermsMethod,
  KioskRegistrationType,
} from '../../types/kioskRegistration.types';

export const STATUS_LABELS: Record<KioskRegistrationStatus, string> = {
  PENDING_REVIEW: 'Pending review',
  AWAITING_CALL: 'Awaiting call',
  AWAITING_AGREEMENT: 'Awaiting agreement',
  AWAITING_PAYMENT: 'Awaiting payment',
  ACTIVE: 'Active',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
};

export const STATUS_ORDER = Object.keys(STATUS_LABELS) as KioskRegistrationStatus[];

export const STATUS_STYLES: Record<KioskRegistrationStatus, string> = {
  PENDING_REVIEW: 'bg-amber-50 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  AWAITING_CALL: 'bg-sky-50 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  AWAITING_AGREEMENT: 'bg-indigo-50 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-200',
  AWAITING_PAYMENT: 'bg-orange-50 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
  ACTIVE: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  REJECTED: 'bg-red-50 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  CANCELLED: 'bg-gray-100 text-gray-700 dark:bg-slate-700 dark:text-gray-200',
};

export const TYPE_LABELS: Record<KioskRegistrationType, string> = {
  INDIVIDUAL: 'Individual',
  AMBASSADOR: 'Ambassador',
  CORPORATE: 'Corporate / Organisation',
};

export const CHANNEL_TYPE_LABELS: Record<KioskRegistrationChannelType, string> = {
  DIGITAL: 'Digital',
  PHYSICAL: 'Physical',
  BOTH: 'Digital + physical',
};

export const TERMS_METHOD_LABELS: Record<KioskRegistrationTermsMethod, string> = {
  ON_SCREEN: 'Accepted on screen',
  PANDADOC: 'Signed via PandaDoc',
  ADMIN_ATTESTED: 'Attested by admin',
};

export const ACTION_LABELS: Record<KioskRegistrationAction, string> = {
  APPROVE: 'Approve',
  REJECT: 'Reject',
  CANCEL: 'Cancel registration',
  MARK_CALL_COMPLETED: 'Mark call completed',
  SEND_PROPOSAL: 'Send proposal email',
  MARK_TERMS_SIGNED: 'Mark T&Cs signed',
  MARK_PAYMENT_RECEIVED: 'Mark payment received',
  RESEND_WELCOME: 'Resend welcome email',
};


export const INPUT_CLASS =
  'w-full rounded-xl border border-gray-200 bg-white/80 px-3 py-2.5 text-sm outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 dark:border-white/10 dark:bg-slate-800';

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
}

export function formatCents(cents: number | null | undefined, currency?: string | null): string {
  if (cents === null || cents === undefined) return '—';
  return `${(cents / 100).toFixed(2)} ${currency || 'USD'}`;
}
